;(function($, undefined){
    'use strict';

    var rnn = window.rnn;

    function footerFunctions(){
        $('footer nav ul li div').click(function() {
            $('footer nav ul li div span').toggleClass('cross-close');
            $('footer div.row.otherSites').slideToggle('fast', function() {
                // Animation complete.
            });
        });

        $('footer nav .top').click(function() {
            $('html,body').animate({scrollTop:0},0);
        });
    }

    function headerFunctions(){
        // event for the apn networks button
        $('#mainMenu #navNetwork').click(function (e) {
            e.preventDefault();

            var $footerButton = $('#footerSitesToggle');

            // close the nav
            if ($('.wrapper').hasClass('openNav')) {
                $('.navbar-toggle').click();
            }
            // open the list
            if ($footerButton.find('.cross-close').length === 0) {
                $footerButton.click();
            }
            $('html, body').animate({
                  scrollTop: $("nav.footer").offset().top
            }, 1000);
        });
    }

    function initHeader() {
        footerFunctions();
        headerFunctions();
    }

    rnn.modules.register('header', {
        init: initHeader
    });

})(jQuery);
